import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestConfirmRefund } from "./confirmRefund.request";

const useConfirmRefund = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchMobileMoneyBalance = useRefetchQuery(["mobile-money-balance"]);

  return useMutation({
    mutationFn: requestConfirmRefund,
    ...options,
    onSuccess: (data, variables, context) => {
      refetchMobileMoneyBalance();
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useConfirmRefund;
